app.controller('projectRequestController', function ($http, $scope, $stateParams, $location, dataService, $modal, pageConfig, pageHandler, $timeout, $controller) {

    $scope.showProjectRequest = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views\/project_request.html',
            controller: showProjectRequestController,
            scope: $scope,
            windowClass: 'project-request-window'
        });
    }

    //Controller for project request form
    function showProjectRequestController($http, $q, $scope, $modalInstance) {
        $scope.filesize_limit = 20 * 1024 * 1000;
        $scope.filesize_error_text = "Allowed Max Size : 20 MB.";
        $scope.message_error_text = "Message field is required";
        $scope.project_types = [
            {
                "title": "Market research",
                "description": "(e.g. researching a market or customer/consumer segment with a focus on the purchase and sales of a product, service, or advertising)"
            },
            {
                "title": "Experience/ Design research",
                "description": "(e.g. researching users and customers’ pains, needs and behaviours, and how they use and experience a design, product or service)"
            },
            {
                "title": "Exec reporting",
                "description": "(e.g. updates of key metrics, syndicated research data and insights, multi-data source analysis for key performance metrics and insights)"
            },
            {
                "title": "Strategic design  / service design",
                "description": "(e.g. designing the application of future-oriented design principles to increase our innovative and competitive qualities; customer journey maps and service blueprints)"
            },
            {
                "title": "Program work",
                "description": "(e.g. tracking programs – Pulse, Advertising, sponsorship tracking, campaign evaluations, advocacy insights for continuous service improvements)"
            },
        ];
        $scope.project_type_description = "";
        $scope.$watch('file', function () {
            $scope.filename = $scope.file != undefined && $scope.file.name != undefined ? $scope.file.name : '';
        });
        $scope.alert = false;
        $scope.loading = false;
        $scope.submit = function (formType) {
            $scope.loading = true;
            // If general enquiry, get request form
            if (formType == 'briefing') {
                var formData = new FormData(document.getElementById('briefingForm'));
            } else {
                var formData = new FormData(document.getElementById('requestForm'));
            }
            formData.append('type', formType);
            $http.post('project_request/save', formData, {
                cache: false,
                contentType: false,
                processData: false,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            })
                .success(function (response) {
                    $scope.loading = false;
                    if (response.data.status) {
                        // reset all forms
                        document.getElementById('requestForm').reset();
                        document.getElementById('briefingForm').reset();
                        $scope.alert = {
                            type: 'success',
                            message: response.data.message
                        };
                        setTimeout(function () {
                            $modalInstance.close();
                        }, 2000);
                    } else {
                        $scope.alert = {
                            type: 'danger',
                            message: '<strong>Sorry!</strong> An error occurred while submitting the form. Please try again!'
                        };
                    }
                })
                .error(function (reject) {
                    $scope.alert = {
                        type: 'danger',
                        message: '<strong>Sorry!</strong> The request failed. Please try again!'
                    };
                });
        }
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.closeAlert = function () {
            $scope.alert = false;
        }
        $scope.updateDescription = function (project_type) {
            var description = '';
            angular.forEach($scope.project_types, function (value, key) {
                if (value.title === project_type) {
                    description = value.description;
                }
            });
            $scope.project_type_description = description;
        }
    }

});
